// Webpack Imports
import $ from "jquery";



$.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
$.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};

$.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
$.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

!function(e){"function"==typeof define&&define.amd?define(e):e()}(function(){var e,t=["scroll","wheel","touchstart","touchmove","touchenter","touchend","touchleave","mouseout","mouseleave","mouseup","mousedown","mousemove","mouseenter","mousewheel","mouseover"];if(function(){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){e=!0}});window.addEventListener("test",null,t),window.removeEventListener("test",null,t)}catch(e){}return e}()){var n=EventTarget.prototype.addEventListener;e=n,EventTarget.prototype.addEventListener=function(n,o,r){var i,s="object"==typeof r&&null!==r,u=s?r.capture:r;(r=s?function(e){var t=Object.getOwnPropertyDescriptor(e,"passive");return t&&!0!==t.writable&&void 0===t.set?Object.assign({},e):e}(r):{}).passive=void 0!==(i=r.passive)?i:-1!==t.indexOf(n)&&!0,r.capture=void 0!==u&&u,e.call(this,n,o,r)},EventTarget.prototype.addEventListener._original=e}});


import { Collapse, Dropdown, Modal  } from 'bootstrap';
import './jss/slick';


(function ($) {
  $(document).ready(function () {

    $('#langSwitcher').on('click', function () {
       $('#langList').fadeToggle();
    });

    $('#searchSwitcher').on('click', function () {
       $('#searchForm').fadeToggle();
    });


    $('a').each(function () {
      if (location.hostname === this.hostname || 'geographicatrophy.eu' === this.hostname || !this.hostname.length || 'pre-lesion.com' === this.hostname ||  'geographicatrophy.com.au' === this.hostname ||  'dryamd.eu' === this.hostname ||  'apellis.com' === this.hostname || 'apellismedicalhub.com' === this.hostname) {
        $(this).addClass('local');
      } else {
        $(this).addClass('external');
      }
    });

    $('a.external').click(function (e) {

      e.preventDefault();
      //console.log("extern clicked");

      $('#externalLink').addClass('show');

      var target = $(this).attr('target');
      var uri = $(this).attr('href');

      //console.log("target, uri:", target, uri);

      $('#externalLink .externalLink-ok').unbind();
      $('#externalLink .externalLink-ok').click(function (e) {

        var link = document.createElement('a');
        link.href = uri;
        link.target = target;
        document.body.appendChild(link);
        link.click();

        $('#externalLink').removeClass('show');

        return true;

      });

      $('#externalLink .externalLink-close').unbind();
      $('#externalLink .externalLink-close').click(function (e) {

        $('#externalLink').removeClass('show');

        return true;

      });

    });

	  
	/**
	 * COOKIE BANNER
	 */
    const cookieBanner = $('#cookieBanner');

    if (cookieBanner.length) {

      let cookieBannerClose = $('.cookieBanner-close');
      let cookieBannerNo = $('.cookieBanner-no');

      cookieBannerClose.on('click', function (e) {
        e.preventDefault();
        setCookie('cookieBanner', 'active', 365);
        cookieBanner.fadeOut();
      });

      cookieBannerNo.on('click', function (e) {
        e.preventDefault();
        setCookie('cookieBanner', 'no', 365);
        cookieBanner.fadeOut();
        document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
        window[disableStr] = true;
      });
	}
	  
	  
	/**
	 * Professional
	 */
    const profBanner = $('#profBanner');

    if (profBanner.length) {
		
      let profBannerClose = $('.profBanner-close');

      profBannerClose.on('click', function (e) {
        e.preventDefault();
        setCookie('profBanner', 'active', 30);
        profBanner.fadeOut();
      });
	}

    
    const openPoll = $('#openPoll');
  
    if (openPoll.length) {
      const pollBanner = $('#pollBanner');
      let pollClose = $('.pollBanner-close');

      pollClose.on('click', function (e) {
        e.preventDefault();
        pollBanner.removeClass('show');
      });

      $('body').on('click', '.pollBanner-finish', function (e) {
        e.preventDefault();
        pollBanner.removeClass('show');
      });

      openPoll.on('click', function (e) {
        e.preventDefault();
        pollBanner.addClass('show');
      });

    }
	  
  });


function setCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}




let videoPlayers = $('.video-player');

if (videoPlayers.length) {
    videoPlayers.each(function () {
      const videoBlock = $(this).find('.wp-block-video');
      const videoButtons = $(this).find('.specialButton__button');

      //only show the first video
        videoBlock.hide();
        videoBlock.eq(0).show();
      

      videoButtons.each(function (index) { 
        $(this).on('click', function (e) {
          e.preventDefault();
          //videoPlayers.hide();

          if($(this).hasClass('active') && !$(this).hasClass('paused')){
            // this video is playing so pause it
            videoBlock.eq(index).find('video').trigger('pause');
            $(this).addClass('paused');
          }else if($(this).hasClass('paused')){
            // this video is paused so play it
            videoBlock.eq(index).find('video').trigger('play');
            $(this).removeClass('paused');
            console.log('restart?')
          }else{
            //another video has been triggered
            videoBlock.each(function () {
              $(this).hide();
              $(this).find('video').trigger('pause');
            });
            videoButtons.each(function (index) { 
              $(this).removeClass('active');
              $(this).removeClass('paused');
            });

            $(this).addClass('active');
            videoBlock.eq(index).show();
            videoBlock.eq(index).find('video').trigger('play');
          }
          
        });
      });

    });
}






  if ($('.init_slider').length) {
		$('.init_slider').slick({
			dots: true,
			speed: 500,
			infinite: false,
			prevArrow: $('.prev'),
			nextArrow: $('.next'),
			customPaging : function(slider, i) {
				return '<a href="#"><div class="slick-dot-custom"></div></a>';
			},
		});
	}

	if ($('.headerSlick-init').length) {
		$('.headerSlick-init').slick({
			dots: true,
			speed: 700,
			infinite: true,
			autoplay: true,
      autoplaySpeed: 6000,
			prevArrow: $('.prev'),
			nextArrow: $('.next'),
      customPaging : function(slider, i) {
				return '<a href="#"><div class="slick-dot-custom"></div></a>';
			},
		});
	}

  // play/pause bill's story video on unmet need page
  const videoBill = $('#bills-story-vid video');
  const videoBtnBill = $('#bills-story-btn');
  
  
  videoBtnBill.on('click', function (e) {
    e.preventDefault();
  
    if (videoBtnBill.hasClass('active') && !videoBtnBill.hasClass('paused')){
      // this video is playing so pause it
      videoBill.trigger('pause');
      videoBtnBill.removeClass('active');
      videoBtnBill.addClass('paused');
    } else {
      // this video is paused so play it
      videoBill.trigger('play');
      videoBtnBill.removeClass('paused');
      videoBtnBill.addClass('active');
    }
    
  });

  const videoOveractivation = $('#overactivation-video video');

  videoOveractivation.on('play', function (e){
    e.preventDefault();
    $('.video-col-btn-overlay').removeClass('paused');
  })
  videoOveractivation.on('pause', function (e){
    e.preventDefault();
    $('.video-col-btn-overlay').addClass('paused');
  })

  const subscriptionSubmitBtn = document.getElementsByClassName('noptin-form-submit');

  if (subscriptionSubmitBtn != null && subscriptionSubmitBtn.length > 0){
    const element = subscriptionSubmitBtn[0]
    var in_dom = document.body.contains(element);

    var observer = new MutationObserver(function(mutations) {
        if (document.body.contains(element)) {
            in_dom = true;
        } else if (in_dom) {
            in_dom = false;
            const sectionContainer = document.getElementsByClassName('newsletter-section');

            if (sectionContainer != null && sectionContainer.length > 0){
              const innerContainer = sectionContainer[0].lastChild;
              const nodeList = innerContainer.childNodes;
              
              // remove headings and spacer between them
              if (nodeList.length == 13){
                nodeList.item(2).innerHTML = `<svg width="194" height="194" viewBox="0 0 194 194" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2125_32754)">
                <path d="M191.812 89.3204C192.845 89.2367 193.753 90.0066 193.817 91.0415C195.046 111.014 190.068 130.896 179.542 147.95C168.686 165.536 152.497 179.196 133.334 186.938C114.172 194.679 93.0377 196.098 73.0123 190.987C52.987 185.876 35.1175 174.503 22.0088 158.525C8.89998 142.547 1.23723 122.8 0.137477 102.162C-0.962275 81.5236 4.55847 61.0738 15.895 43.7932C27.2314 26.5125 43.791 13.3045 63.1598 6.09434C81.9416 -0.897315 102.413 -1.89464 121.76 3.21339C122.763 3.47806 123.34 4.51854 123.056 5.51572V5.51572C122.772 6.5129 121.734 7.0891 120.732 6.82521C102.154 1.93584 82.5018 2.9006 64.4697 9.61316C45.8507 16.5442 29.9321 29.241 19.0344 45.8527C8.13674 62.4645 2.8297 82.1227 3.88688 101.962C4.94406 121.801 12.3102 140.784 24.9115 156.143C37.5129 171.503 54.6907 182.436 73.9408 187.349C93.191 192.262 113.507 190.898 131.928 183.456C150.349 176.014 165.911 162.883 176.347 145.977C186.453 129.604 191.239 110.52 190.074 91.3447C190.011 90.3097 190.779 89.4041 191.812 89.3204V89.3204Z" fill="#C8A85D"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M186.613 23.6629C187.855 24.7413 187.988 26.6224 186.91 27.8646L92.7923 136.278C92.2292 136.927 91.4135 137.301 90.5546 137.304C89.6956 137.307 88.8771 136.94 88.309 136.295L48.3986 91.0236C47.3108 89.7897 47.4292 87.9076 48.6631 86.8198C49.897 85.7321 51.7791 85.8505 52.8669 87.0844L90.526 129.802L182.411 23.9595C183.49 22.7174 185.371 22.5846 186.613 23.6629Z" fill="white"/>
                </g>
                <defs>
                <clipPath id="clip0_2125_32754">
                <rect width="194" height="194" fill="white"/>
                </clipPath>
                </defs>
                </svg>
                `;
                nodeList.item(4).remove();
                nodeList.item(5).remove();
              }
            }
        }
  
    });
    observer.observe(document.body, {childList: true, subtree: true});

  }


})($);

